import { MutableData } from '@polymer/polymer/lib/mixins/mutable-data.js';
import { html } from '../../../mixins/katapult-element.js';
import { KatapultModelEditorElement } from '../katapult-editor-template.js';
import { PortalStyle } from '../katapult-model-editor-style.js';
import '@polymer/paper-checkbox/paper-checkbox.js';
import '@polymer/paper-input/paper-input.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import '../../user-chip/user-chip.js';
import '../../paper-header/paper-header.js';
import '../../paper-table/paper-table.js';
import '../../material-icon/material-icon.js';
import '../../katapult-drop-down/katapult-drop-down.js';
import '../../katapult-elements/katapult-button.js';
import '../../style-modules/paper-table-style.js';
import { GeneratePushID } from '../../../modules/GeneratePushID.js';

/** Email Template Editor */
customElements.define(
  'workflow-action-email-template',
  class extends MutableData(KatapultModelEditorElement) {
    static get template() {
      return html`
        <!-- Style -->
        ${PortalStyle}
        <!-- User Editable -->
        <paper-row checkbox pointer>
          <paper-cell icon>
            <material-icon icon="edit"></material-icon>
          </paper-cell>
          <paper-cell shrink>User Editable</paper-cell>
          <paper-cell icon>
            <paper-checkbox
              checked="[[template.options.portal_user_editable]]"
              data-path="template.options.portal_user_editable"
              on-change="toggleProperty"
            ></paper-checkbox>
          </paper-cell>
          <paper-cell italic>Should the user be able to see and modify this email before it is sent?</paper-cell>
        </paper-row>
        <!-- Send to Applicant -->
        <paper-row checkbox pointer>
          <paper-cell icon>
            <material-icon icon="person"></material-icon>
          </paper-cell>
          <paper-cell shrink>Send to Applicant</paper-cell>
          <paper-cell icon>
            <paper-checkbox
              checked="[[template.options.portal_send_to_applicant]]"
              data-path="template.options.portal_send_to_applicant"
              on-change="toggleProperty"
            ></paper-checkbox>
          </paper-cell>
        </paper-row>
        <!-- Send to Utility -->
        <paper-row checkbox pointer>
          <paper-cell icon>
            <material-icon icon="engineering"></material-icon>
          </paper-cell>
          <paper-cell shrink>Send to Utility</paper-cell>
          <paper-cell icon>
            <paper-checkbox
              checked="[[template.options.portal_send_to_utility]]"
              data-path="template.options.portal_send_to_utility"
              on-change="toggleProperty"
            ></paper-checkbox>
          </paper-cell>
        </paper-row>
        <!-- Addresses -->
        <paper-row expand>
          <paper-cell icon>
            <material-icon icon="alternate_email"></material-icon>
          </paper-cell>
          <paper-cell shrink>Additional Addresses</paper-cell>
          <paper-cell>
            <workflow-action-email-list
              emails="[[template.addresses]]"
              data-path="template.addresses"
              on-emails-changed="updateProperty"
              grow
            ></workflow-action-email-list>
          </paper-cell>
        </paper-row>
        <!-- Subject -->
        <paper-row input>
          <paper-cell icon>
            <material-icon icon="subject"></material-icon>
          </paper-cell>
          <paper-cell shrink>Subject</paper-cell>
          <paper-cell>
            <paper-input
              label="Subject"
              value="[[template.subject]]"
              data-path="template.subject"
              no-label-float
              underline
              on-value-changed="updateProperty"
            ></paper-input>
          </paper-cell>
        </paper-row>
        <!-- Body -->
        <paper-row input expand>
          <paper-cell icon>
            <material-icon icon="email"></material-icon>
          </paper-cell>
          <paper-cell shrink>Body</paper-cell>
          <paper-cell>
            <paper-textarea
              label="Body"
              value="[[template.body]]"
              data-path="template.body"
              no-label-float
              on-value-changed="updateProperty"
            ></paper-textarea>
          </paper-cell>
        </paper-row>
        <!-- Template Items -->
        <paper-row expand>
          <paper-cell icon>
            <material-icon icon="data_object"></material-icon>
          </paper-cell>
          <paper-cell shrink>Template Items</paper-cell>
          <paper-cell>
            <!-- Table -->
            <paper-table rounded white outline dividers grow overflow-hidden>
              <paper-table-scroll data-path="template.template_items" on-sort-changed="orderedItemsArraySortChanged">
                <!-- Header -->
                <paper-row grey short slot="before">
                  <paper-cell icon>
                    <material-icon icon="swap_vert"></material-icon>
                  </paper-cell>
                  <paper-cell>Name</paper-cell>
                  <paper-cell>Value</paper-cell>
                  <paper-cell icon></paper-cell>
                </paper-row>
                <!-- Body -->
                <template is="dom-repeat" items="[[getOrderedItemsArray(template.template_items.*)]]" mutable-data>
                  <paper-header-content
                    data-path="template.template_items.$(model.item.$key)"
                    on-opened-changed="updateProperty"
                    on-render-changed="updateProperty"
                    slot="sortable"
                    opened="[[item.$opened]]"
                    divider
                    no-click-row
                  >
                    <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>
                    <paper-cell slot="header" input>
                      <paper-input
                        label="Name"
                        value="[[item.name]]"
                        data-path="template.template_items.$(model.item.$key).name"
                        no-label-float
                        on-value-changed="updateProperty"
                      ></paper-input>
                    </paper-cell>
                    <paper-cell slot="header-end" icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        icon="delete"
                        data-path="template.template_items.$(model.item.$key)"
                        data-value="$null"
                        on-click="updateProperty"
                      ></katapult-button>
                    </paper-cell>
                    <template is="dom-if" if="[[item.$render]]" restamp>
                      <div slot="content">
                        <!-- Value -->
                        <paper-row expand>
                          <paper-cell icon>
                            <material-icon icon="input"></material-icon>
                          </paper-cell>
                          <paper-cell shrink>Value</paper-cell>
                          <paper-cell shrink>
                            <k-logic-editor
                              block="[[item.value]]"
                              data-path="template.template_items.$(model.item.$key).value"
                              on-block-changed="updateProperty"
                            ></k-logic-editor>
                          </paper-cell>
                        </paper-row>
                      </div>
                    </template>
                  </paper-header-content>
                </template>
                <!-- Add Button -->
                <paper-row class="addButton" ripple short slot="after" data-path="template.template_items" on-click="addOrderedItem">
                  <paper-cell>
                    <material-icon icon="playlist_add"></material-icon>
                    <div>Add a Template Item</div>
                  </paper-cell>
                </paper-row>
              </paper-table-scroll>
            </paper-table>
          </paper-cell>
        </paper-row>
      `;
    }

    constructor() {
      super();
    }

    static get properties() {
      return { template: { type: Object, notify: true } };
    }
  }
);

/** Email List */
customElements.define(
  'workflow-action-email-list',
  class extends MutableData(KatapultModelEditorElement) {
    static get template() {
      return html`
        <!-- Style -->
        ${PortalStyle}
        <paper-table white rounded outline dividers>
          <template is="dom-repeat" items="[[getOrderedItemsArray(emails)]]">
            <paper-row>
              <paper-cell icon>
                <user-chip email="[[item.email]]" hide-name></user-chip>
              </paper-cell>
              <paper-cell>[[item.email]]</paper-cell>
              <paper-cell icon-button>
                <katapult-button
                  iconOnly
                  noBorder
                  icon="clear"
                  data-value="$null"
                  data-path="emails.$(model.item.$key)"
                  callback="updateProperty"
                ></katapult-button>
              </paper-cell>
            </paper-row>
          </template>
          <paper-row input>
            <paper-cell>
              <paper-input id="emailAddressInput" label="Enter Email Address" pattern=".+@.+" required no-label-float></paper-input>
              <iron-a11y-keys keys="enter" on-keys-pressed="addEmail"></iron-a11y-keys>
            </paper-cell>
            <paper-cell icon-button>
              <katapult-button iconOnly noBorder icon="add" on-click="addEmail"></katapult-button>
            </paper-cell>
          </paper-row>
        </paper-table>
      `;
    }
    static get properties() {
      return { emails: { type: Object, notify: true } };
    }

    constructor() {
      super();
    }

    addEmail() {
      // Get the input.
      const input = this.$$('#emailAddressInput');
      // Check that email is valid. and not already in the list.
      if (input.validate()) {
        const value = input.value.trim();
        if (this.getOrderedItemsArray(this.emails ?? {}).find((x) => x.email == value) == null) {
          // Build the new email item.
          const item = { email: value, type: 'to' };
          const path = `emails.${GeneratePushID()}`;
          this.deepSet(path, item);
          // Clear the input.
          input.value = '';
        }
      }
    }
  }
);
